import classNames from "classnames";
import { ReactNode } from "react";

import styles from "./Paper.module.css";

const Paper: React.FC<PaperProps> = ({
  className,
  children,
  elevation,
  ...rest
}) => {
  return (
    <div
      className={classNames(styles.paper, className, {
        [styles["elevation-1"]]: elevation === 1,
        [styles["elevation-2"]]: elevation === 2,
      })}
      {...rest}
    >
      {children}
    </div>
  );
};

export type PaperProps = {
  children?: ReactNode;
  elevation?: 0 | 1 | 2;
} & React.HTMLProps<HTMLDivElement>;

export default Paper;
